export default {
  'admin': {
    'access_title': 'Admin',
    'access_group': 'Group',
    'access_success': 'Access success',
    
    'select_avatar': 'Select avatar',
    
    'form_passport': 'Passport',
    'form_enter_passport': 'enter passport',
    'form_nickname': 'Nickname',
    'form_enter_nickname': 'enter nickname',
    'form_email': 'Email',
    'form_enter_email': 'enter email',
    'form_group': 'Group',
    'form_need_one_group': 'need one group',
    'form_introduce': 'Introduce',
    'form_enter_introduce': 'enter introduce',
    'form_avatar': 'Avatar',
    'form_status': 'Status',
    'form_status_enable': 'Enable',
    'form_status_disable': 'Disable',
    
    'rules_name_required': 'name required',
    'rules_nickname_required': 'nickname required',
    'rules_email_required': 'email required',
    'rules_group_id_required': 'group_id required',
    'rules_introduce_required': 'introduce required',
    
    'create_success': 'create success',
    'update_success': 'update success',
    
    'search_title': 'Admin',
    'search_searchword': 'enter keywords',
    'search_status': 'Status',
    'search_btn': 'Search',
    'search_create_passport': 'Create',
    'search_clear_cache': 'Refresh',
    'search_passport_logout': 'Logout',
    
    'table_name': 'Name',
    'table_nickname': 'Nickname',
    'table_create_time': 'CreateTime',
    'table_status': 'Status',
    'table_actions': 'Actions',
    'table_setting_group': 'SettingGroup',
    'table_password': 'Password',
    'table_detail': 'Detail',
    'table_update': 'Update',
    'table_delete': 'Delete',
    'table_enable': 'Enable',
    'table_disable': 'Disable',
    'table_asc': 'Asc',
    'table_desc': 'Desc',
    'table_enable_success': 'enable success',
    'table_disable_success': 'disable success',
    
    'dialog_detail': 'Detail',
    'dialog_create': 'Create',
    'dialog_edit': 'Edit',
    'dialog_password': 'Chpassword',
    'dialog_password_newpassword': 'Newpassword',
    'dialog_Logout': 'logout',
    'dialog_logout_refreshToken': 'refreshToken',
    'dialog_logout_tips': 'put refreshToken to blocklist',
    'dialog_logout_ok': 'logout',
    'dialog_access': 'access group',

    'detail_id': 'ID',
    'detail_name': 'Name',
    'detail_nickname': 'Nickname',
    'detail_email': 'Email',
    'detail_introduce': 'Introduce',
    'detail_groups': 'Groups',
    'detail_avatar': 'Avatar',
    'detail_create_time': 'JoinTime',
    'detail_last_active': 'LastActive',
    'detail_last_ip': 'LastIp',
    'detail_status': 'Status',
    
    'confirm_delete': 'confirm delete admin?',
    'confirm_delete_success': 'delete admin success',
    'password_not_empty': 'password not empty',
    'password_change_success': 'change password success',
    'confirm_update_cache': 'confirm update cache?',
    'confirm_updateing_cache': 'updateing cache...',
    'confirm_update_cache_success': 'update cache success',
    'refreshToken_not_empty': 'refreshToken not empty',
    'logout_success': 'logout success',
  },
}
